var _rect, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuskPhotographywithCompanion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.800293,
    y: 3.80078,
    width: 13.7997,
    height: 11.3746,
    rx: 0.5,
    stroke: "#404041",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3157 14.6465C14.4753 14.8362 14.457 15.1646 14.2092 15.1646V15.1646H1.19061V15.1646C0.942753 15.1646 0.924492 14.8362 1.08406 14.6465L4.06167 11.1075C4.27352 10.8557 4.61695 10.8557 4.82879 11.1075L5.14656 11.4852C5.3584 11.737 5.70184 11.737 5.91368 11.4852L8.4012 8.52868C8.61304 8.2769 8.95648 8.2769 9.16832 8.52868L14.3157 14.6465Z",
    stroke: "#404041",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44869 9.57214C2.78905 9.57214 2.25244 9.02853 2.25244 8.36029C2.25244 7.69205 2.78905 7.14844 3.44869 7.14844C4.10833 7.14844 4.64494 7.69205 4.64494 8.36029C4.64494 9.02853 4.10833 9.57214 3.44869 9.57214Z",
    stroke: "#404041",
    strokeWidth: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8325 16.5466V17.6195C11.8325 17.8254 11.9588 18.0103 12.1506 18.0852L15.7661 19.4977C15.9099 19.5539 16.0715 19.5405 16.204 19.4615L19.3879 17.5645C19.5392 17.4743 19.6319 17.3112 19.6319 17.135V13.7104C19.6319 13.4975 19.4971 13.3079 19.296 13.2381L15.7322 12",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.8008L15.9229 14.9773",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3719 13.3477L15.9922 14.9734V19.5796",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuskPhotographywithCompanion);
export default __webpack_public_path__ + "static/media/DuskPhotographywithCompanion.451136a58077941e561f26fff1e4e621.svg";
export { ForwardRef as ReactComponent };